__turbopack_context__.v({
  "className": "dm_sans_e09feb52-module__McQkyq__className",
  "variable": "dm_sans_e09feb52-module__McQkyq__variable",
});
